import {
  useGetQuantifyAggregatePeriod,
  useGetQuantifyDuration,
} from '@modules/quantify/hooks';
import { useGetQuantifyCompareQuery } from '@modules/quantify/hooks/useGetQuantifyCompareQuery';
import { useGetQuantifyWhereClause } from '@modules/quantify/hooks/useGetQuantifyWhereClause';
import { useQuantifyStore } from '@modules/quantify/store/quantifyStore';
import { getDeltaClause, getGroupBy } from '@modules/quantify/utils';
import { useTaxonomyStore } from '@modules/taxonomy/store/taxonomyStore';
import { QuantifyVisualisationType } from 'generated/graphql';
import { EQLProps, ExpressionType } from 'v2/core/repository/eql/types';
import { useGetUser } from 'v2/core/services/user';

interface GetQuantifyBaseEQLPropsOptions {
  shouldIncludeDashboardFilters?: boolean;
}

export const useGetQuantifyBaseEQLProps = ({
  shouldIncludeDashboardFilters = true,
}: GetQuantifyBaseEQLPropsOptions = {}): Omit<EQLProps, 'sourceDetailsMap'> => {
  const {
    tenant: { timezone },
  } = useGetUser();
  const taxonomyID = useTaxonomyStore(({ taxonomyID }) => taxonomyID ?? '');
  const groupBy = useQuantifyStore(({ query }) => query.groupByField);
  const aggregatePeriod = useGetQuantifyAggregatePeriod();
  const visualisationType = useQuantifyStore(
    ({ query }) => query.visualisationType,
  );

  const compareQuery = useGetQuantifyCompareQuery({
    shouldIncludeDashboardFilters,
  });
  const whereClause = useGetQuantifyWhereClause({
    shouldIncludeDashboardFilters,
  });
  const duration = useGetQuantifyDuration();

  const dateRange = duration as EQLProps['dateRange'];
  const shouldShowCategories = useQuantifyStore(
    ({ visual }) => visual.shouldShowCategories,
  );

  const getAggregatePeriod = () => {
    if (visualisationType === QuantifyVisualisationType.Trend) {
      return aggregatePeriod;
    }

    return undefined;
  };

  return {
    timezone,
    taxonomyID,
    dateRange,
    whereClause,
    expressionType: ExpressionType.Aggregates,
    groupBy: getGroupBy(groupBy, shouldShowCategories),
    aggregatePeriod: getAggregatePeriod(),
    delta: getDeltaClause(compareQuery),
  };
};
